import { render } from "./StoryReader.vue?vue&type=template&id=2dee6190&scoped=true"
import script from "./StoryReader.vue?vue&type=script&lang=js"
export * from "./StoryReader.vue?vue&type=script&lang=js"

import "./StoryReader.vue?vue&type=style&index=0&id=2dee6190&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dee6190"]])

export default __exports__